<template>
  <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%">
    <el-table-column
            fixed
            type="index"
            label="序号"
            :index="indexMethod"
            width="100">
    </el-table-column>
    <el-table-column
            fixed
            prop="orderId"
            label="订单编号"
            width="180">
    </el-table-column>
    <el-table-column
            prop="userName"
            label="下单用户名称"
            width="180">
    </el-table-column>
    <el-table-column
            prop="orderCreateTime"
            label="订单创建时间"
            width="180">
    </el-table-column>
    <el-table-column
            prop="state"
            label="订单状态"
            width="180">
    </el-table-column>
    <el-table-column
            prop="skuName"
            label="商品名称"
            width="180">
    </el-table-column>
    <el-table-column
            prop="skuNumber"
            label="购买商品数量"
            width="180">
    </el-table-column>
    <el-table-column
            prop="skuPrice"
            label="商品单价"
            width="180">
    </el-table-column>
    <el-table-column
            prop="skuSumPrice"
            label="商品总价"
            width="180">
    </el-table-column>
    <el-table-column
            fixed="right"
            label="操作"
            width="150">
      <template slot-scope="scope">
        <el-button type="text" size="small" @click="view(scope.row.id)">查看</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
  export default {
    name: "orderTable",
    props: {
      tableData: Array
    },
    data() {
      return {
      }
    },
    methods: {
      indexMethod(index) {
        return index+1;
      },
      view(id){
        this.$router.push("/order/data/"+id)
      }
    },
  }
</script>

<style scoped>
  .red{
    color: red;
  }
</style>
